import '@/components/inventory';

export default {
    name: 'inventory',
    data() {
        return {
            view: this.getParameterByName('view') || 'assets',
            transition: 'component-slide-fade-up',
            auth: JSON.parse(window.localStorage.getItem('authenticated')),
            alert: null,
            redirect: '',
            selectedCategory: {},
            propertyName: '',
            selectedAssetLocation: []
        };
    },
    created() {
        this.redirect = this.getParameterByName('redirect_to');

        // Handle the back and forward buttons to set the view from the history.
        window.onpopstate = () => {
            // Get view param value from url.
            let view = this.getParameterByName('view');

            if (!view) {
                view = 'assets';
            }

            // Set view data object within component to view from url.
            this.view = view;
        };

        this.$routingBus.$on('changeView', view => {
            this.view = view;
        });
    },
    // Watch events for this main component.
    watch: {
        // Watch view change to set update the history queue with new view.
        // This will allow for back and forward buttons to work.
        view(componentName) {
            if (history.pushState) {
                // Create path with component view param.
                var protocol = window.location.protocol,
                    host = window.location.host,
                    path = window.location.pathname,
                    url = `${protocol}//${host}${path}?view=${componentName}`;

                // Push path to the browser history.
                window.history.pushState({ path: url }, '', url);
            }
        }
    },
    methods: {
        showAlert() {
            let alert = {
                message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                status: 'danger',
                icon: 'exclamation-circle-outline'
            };

            this.alert = alert;
            setTimeout(() => {
                this.alert = null;
            }, 3000);
        },
        // Get a specific url parameter by the name of that parameter.
        // This is used for getting the view that should show based on url.
        getParameterByName(name, url) {
            // Set url to the window url if the variable is null from the passed param.
            if (!url) {
                url = window.location.href;
            }

            // Prep the passed in name for regex.
            name = name.replace(/[[\]]/g, '\\$&');

            // Use regular expressions to get the param and it's value.
            var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
                results = regex.exec(url);

            // If no results, return null.
            if (!results) {
                return null;
            }

            // If the value is empty, return empty string.
            if (!results[2]) {
                return '';
            }

            // Else return the value that was grabbed from the url.
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    }
};
